// ========================================================================================
/*
  enablePrevDays          [bool]
  triggerSelection        [func]
  triggerGeneralSelector  [func]
  selectedList            [arr]
 */
// ========================================================================================



import React, { useEffect } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import moment from 'moment';

// Actions
import { addActiveAppointment } from 'src/views/practitioner/Appointment/reducers/actions';
import { setBackUrl, resetBackUrl } from '../../../reducer/commonActions';

// Components
import ExtComp from '../external';

// Services
import { convertStatusToRowClass } from 'src/views/practitioner/services/appointmentUI';

// Styles & Images
import s from './MultiSelectTable.style';


const MultiSelectTable = (props) => {
  const { t,
    filterAppointmentsList,
    dispatch, backUrl, enablePrevDays,
    triggerSelection,
    triggerGeneralSelector,
    selectedList
  } = props;


  const goToAppointmentDetails = (appoint) => {
    dispatch(addActiveAppointment(appoint));
    dispatch(setBackUrl({ selectedList: selectedList }));
    dispatch(push(`/practitioner/appointments/${appoint.id}/appointment`));
  };

  useEffect(() => {    
    if (filterAppointmentsList.length && backUrl && backUrl.params && backUrl.params.selectedList) {
      dispatch(resetBackUrl());
    }     
  }, [filterAppointmentsList]);

  const isDisableSelection = !filterAppointmentsList ||
    filterAppointmentsList.length === 0 ||
    (
      !enablePrevDays &&
      moment(moment(filterAppointmentsList[0].dateTime).startOf('day')).isBefore(moment().startOf('day'))
    );

  return (
    Array.isArray(filterAppointmentsList) && filterAppointmentsList.length ?

      <s.Table>
        {/* ──── Header ──────────────────────────────────────────────────────────────────────── */}

        <thead>
          <tr className="table-header">
            <th className="triggers">
              <s.CheckBoxEl
                disabled={isDisableSelection}
                checked={selectedList.length === filterAppointmentsList.length}
                halfChecked={selectedList.length && selectedList.length < filterAppointmentsList.length}
                onClick={triggerGeneralSelector} />
            </th>
            <th className="time">{t('time')}</th>
            <th className="patient" style={{ paddingLeft: '30px', textAlign: 'left' }}>
              {t('patient')}
            </th>
            <th className="ap-type">{t('resch_appointment_type')}</th>
            <th className="note">{t('note')}</th>
          </tr>
        </thead>

        {/* ──── Body ────────────────────────────────────────────────────────────────────────── */}
        <tbody>
          {filterAppointmentsList.map((appointment) => {
            return (
              <s.TableRow
                disabled={isDisableSelection}
                key={appointment.id}
                active={selectedList.includes(appointment.id)}
                className={`${convertStatusToRowClass(appointment)}`}
              >
                {/* ──── Triggers ───────────────────────────────────────────────────────────── */}
                <td className="triggers">
                  <s.CheckBoxEl
                    onClick={() => { if (!isDisableSelection) triggerSelection(appointment.id); }}
                    checked={selectedList.includes(appointment.id)}
                    disabled={isDisableSelection} />
                </td>

                {/* ──── Appointment time ──────────────────────────────────────────────────── */}
                <td className="time" onClick={() => { goToAppointmentDetails(appointment); }}>
                  <ExtComp.TimeBlockForTable appointment={appointment} />
                </td>

                {/* ──── Patient ───────────────────────────────────────────────────────────── */}
                <td className="patient" onClick={() => { goToAppointmentDetails(appointment); }}>
                  <ExtComp.PatientBlockForTable patient={appointment.patient} />
                </td>

                {/* ──── Appointment type ──────────────────────────────────────────────────── */}
                <td className="ap-type" onClick={() => { goToAppointmentDetails(appointment); }}>
                  {t(appointment.appointmentType || 'unscheduled')}
                </td>

                {/* ──── Note ──────────────────────────────────────────────────────────────── */}
                <td className="note" onClick={() => { goToAppointmentDetails(appointment); }}>
                  <ExtComp.NoteBlockForTable note={appointment.note} />
                </td>

              </s.TableRow>
            );
          })}
        </tbody>

      </s.Table>
      :

      <s.EmptyBlock>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="88" height="96" viewBox="0 0 88 96">
            <g fill="none" fillRule="evenodd">
              <path fill="#DBDCE1" fillRule="nonzero"
                d={`M56 24c6.8 0 12 5.2 12 12v20h8V36c0-9.6-7.2-18-16.4-19.6C58 7.2 49.6 0 
                40 0H0v96h52v-8H8V8h32c6.8 0 12 5.2 12 12v4h4zm-36 
                4v8h16v-8H20zm56 48V64h-8v12H56v8h12v12h8V84h12v-8H76zM20 52h40v-8H20v8z`} />
            </g>
          </svg>
          <p>{t('placeholder_no_appointments')}</p>
        </div>
      </s.EmptyBlock>
  );
};

const mapStateToProps = state => ({
  backUrl: state.practitioner.common.backUrl,
});

export default translate()(
  connect(
    mapStateToProps,
  )(MultiSelectTable)
);
